var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VProgressCircular',{staticClass:"absolute center",attrs:{"indeterminate":"","color":"#e5e7eb"}})}
var staticRenderFns = []

export { render, staticRenderFns }